export const PROPS_TREE_EXPANSION_STORAGE_KEY = 'propsTreeExpansion';
